import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseEdit } from '../base-edit';
import { ViewModelProperty } from '../../models';


@Component({
    selector: 'ldw-button-edit',
    templateUrl: './button-edit.component.html',
    styleUrls: ['./button-edit.component.css'],
    standalone: false
})
export class ButtonEditComponent extends BaseEdit {
  @Input() clearButtonEnabled = false;
  @Output() actionClicked = new EventEmitter<ViewModelProperty>()


}
